/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SensorSetup = {
    index: number;
    name: string;
    threshold?: {
        high: number | null;
        low: number | null;
    };
    type: SensorSetup.type;
};
export namespace SensorSetup {
    export enum type {
        BLE = 'ble',
        _1_WIRE = '1-wire',
        THERMO = 'thermo',
    }
}

